// 一覧ページ
if (document.querySelector<HTMLFormElement>('[data-role="photos-select-form"]') !== null) {
  document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector<HTMLFormElement>('[data-role="photos-select-form"]');
    const hiddenFieldsContainer = document.getElementById('hidden-fields');

    if (!form || !hiddenFieldsContainer) return;

    const MAX_SELECTION = 10;

    // localStorage から選択済み画像IDを取得
    const selectedImages: string[] = JSON.parse(localStorage.getItem('selectedImages') || '[]').map(String);

    const checkboxes: HTMLInputElement[] = Array.from(document.querySelectorAll<HTMLInputElement>('.photo-checkbox'));

    /**
     * hidden input を container に追加
     */
    const addHiddenInput = (postId: string) => {
      if (!hiddenFieldsContainer.querySelector<HTMLInputElement>(`#image-${postId}`)) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'images[]';
        input.value = postId;
        input.id = `image-${postId}`;
        hiddenFieldsContainer.appendChild(input);
      }
    };

    /**
     * hidden input を container から削除
     */
    const removeHiddenInput = (postId: string) => {
      hiddenFieldsContainer.querySelectorAll<HTMLInputElement>(`#image-${postId}`).forEach(el => el.remove());
    };

    /**
     * localStorage 更新
     */
    const updateLocalStorage = () => {
      localStorage.setItem('selectedImages', JSON.stringify(selectedImages));
    };

    /**
     * MAX_SELECTION に達したら未チェックを disabled に
     */
    const updateDisabledState = () => {
      const checkedCount = checkboxes.filter(cb => cb.checked).length;
      checkboxes.forEach(cb => {
        if (!cb.checked) cb.disabled = checkedCount >= MAX_SELECTION;
      });
    };

    // ページロード時の復元
    selectedImages.forEach(postId => {
      const checkbox = checkboxes.find(cb => cb.value === postId);
      if (checkbox) checkbox.checked = true;
      addHiddenInput(postId);
    });

    // ページロード時の disabled 状態更新
    updateDisabledState();

    // チェックボックス変更イベント
    checkboxes.forEach(cb => {
      cb.addEventListener('change', () => {
        const postId = cb.value;

        if (cb.checked) {
          // MAX_SELECTION を超える場合はチェックできない
          const checkedCount = checkboxes.filter(c => c.checked).length;
          if (checkedCount > MAX_SELECTION) {
            alert(`選択は最大 ${MAX_SELECTION} 件までです`);
            cb.checked = false;
            return;
          }

          addHiddenInput(postId);

          if (!selectedImages.includes(postId)) {
            selectedImages.push(postId);
            updateLocalStorage();
          }
        } else {
          removeHiddenInput(postId);

          const index = selectedImages.indexOf(postId);
          if (index > -1) {
            selectedImages.splice(index, 1);
            updateLocalStorage();
          }
        }

        updateDisabledState();
      });
    });
  });
}

// フォームページ
document.addEventListener("DOMContentLoaded", () => {
  const selectedPhotosContainer = document.querySelector('[data-role="selected-photos"]') as HTMLElement | null;
  const cf7SelectedPhoto = document.querySelector('#selected-photo') as HTMLElement | null;

  if (!selectedPhotosContainer || !cf7SelectedPhoto) return;

  // ---------------------------------------------------
  // CF7 hidden input （selected_photos）を更新
  // ---------------------------------------------------
  const updateCf7HiddenField = () => {
    const hiddenField = document.querySelector<HTMLInputElement>('#selected_photos');
    if (!hiddenField) return;

    // 現在 #selected-photo 内に入っている <p> のテキストを全部取得
    const texts: string[] = [];
    cf7SelectedPhoto.querySelectorAll('p').forEach(p => {
      texts.push(p.textContent ?? "");
    });

    // 改行でまとめて1つの string として hidden input に入れる
    hiddenField.value = texts.join("\n");
  };

  // ---------------------------------------------------
  // ZIP用 hidden input（selected_post_ids）を更新
  // ---------------------------------------------------
  const updateZipHiddenField = () => {
    const zipHidden = document.querySelector<HTMLInputElement>('#selected_post_ids');
    if (!zipHidden) return;

    const ids: string[] = [];
    selectedPhotosContainer
      .querySelectorAll<HTMLInputElement>('input[name="images[]"]')
      .forEach(input => {
        ids.push(input.value);
      });

    zipHidden.value = ids.join(',');
  };

  // -----------------------------------------
  // 初期生成：selected-photos の hidden input から <p> を生成
  // -----------------------------------------
  const existingInputs = selectedPhotosContainer.querySelectorAll<HTMLInputElement>('input[name="images[]"]');

  existingInputs.forEach(input => {
    const postId = input.value;
    const title = input.dataset.title ?? "";
    const photoId = input.dataset.id ?? ""; // ← 追加：photo_id を取得

    const p = document.createElement("p");
    p.dataset.photoId = postId;

    // (photo_id) タイトル の形
    p.textContent = `(${photoId}) ${title}`;

    cf7SelectedPhoto.appendChild(p);
  });
  updateCf7HiddenField();
  updateZipHiddenField();

  // ---------------------------------------------------
  // 削除ボタンの活性/非活性切り替え
  // ---------------------------------------------------
  const updateDeleteButtons = () => {
    const blocks = document.querySelectorAll<HTMLElement>('[data-post-id]');
    const count = blocks.length;

    blocks.forEach(block => {
      const btn = block.querySelector("button") as HTMLButtonElement | null;
      if (!btn) return;

      if (count <= 1) {
        btn.disabled = true;
        btn.classList.add("opacity-50", "cursor-default");
      } else {
        btn.disabled = false;
        btn.classList.remove("opacity-50", "cursor-default");
      }
    });
  };

  updateDeleteButtons();

  // ---------------------------------------------------
  // localStorage の配列を削除に同期
  // ---------------------------------------------------
  const removeFromLocalStorage = (postId: string) => {
    const stored = localStorage.getItem("selectedImages");
    if (!stored) return;

    const arr = JSON.parse(stored) as string[];
    const newArr = arr.filter(id => id !== postId);
    localStorage.setItem("selectedImages", JSON.stringify(newArr));
  };

  // ---------------------------------------------------
  // 削除ボタン処理
  // ---------------------------------------------------
  const photoBlocks = document.querySelectorAll<HTMLElement>('[data-post-id]');

  photoBlocks.forEach(block => {
    const postId = block.dataset.postId ?? "";
    const button = block.querySelector("button") as HTMLButtonElement | null;

    if (!button) return;

    button.addEventListener("click", () => {
      // 1. 一覧のブロックを削除
      block.remove();

      // 2. selected-photos 内 hidden input 削除
      const removeFromSelected = selectedPhotosContainer.querySelector<HTMLInputElement>(
        `input[name="images[]"][value="${postId}"]`
      );
      removeFromSelected?.remove();

      // 3. CF7 表示用の <p> を削除
      const removeFromCF7 = cf7SelectedPhoto.querySelector<HTMLElement>(
        `[data-photo-id="${postId}"]`
      );
      removeFromCF7?.remove();

      // hidden も更新
      updateCf7HiddenField();

      // 4. localStorage 同期
      removeFromLocalStorage(postId);

      // 5. 削除ボタンの活性/非活性更新
      updateDeleteButtons();
      updateCf7HiddenField();
      updateZipHiddenField();
    });
  });

});
